export type LocalizedTitles = {
  title: string;
  title_ru?: string;
  title_ua?: string;
  title_ar?: string;
};

export type LocalizedPosters = {
  poster_path?: string;
  poster_path_ru?: string;
  poster_path_ua?: string;
  poster_path_ar?: string;
};

// The baked atlases are localized, so the overlay thumbnail has to match them. poster_path is
// the en-US artwork; the suffixed fields only exist where that locale's poster differs.
export const localizedPoster = (movie: LocalizedPosters, language: string) => {
  const localized =
    language === "ru"
      ? movie.poster_path_ru
      : language === "uk"
        ? movie.poster_path_ua
        : language === "ar"
          ? movie.poster_path_ar
          : null;
  return localized || movie.poster_path;
};

// Same locale codes as the rest of the site (see utils/helpers languageHandler).
export const localizedTitle = (movie: LocalizedTitles, language: string) => {
  const localized =
    language === "ru"
      ? movie.title_ru
      : language === "uk"
        ? movie.title_ua
        : language === "ar"
          ? movie.title_ar
          : null;
  return localized || movie.title;
};

// Cells show a window into the baked pool. The window starts on a metadata batch boundary
// (cell.subgrid indexes both the atlas layer and the JSON batch) and wraps around the end of
// the pool — the bake pads the coarse atlases by a pool's worth so wrapped ids still have a
// tile, and batch lookups take a modulo. Wrapping is what makes every batch a possible
// starting point instead of only the (pool - cells) spare ones.
export const pickCellIdOffset = (
  poolCount: number,
  subgridSize: number,
  random: () => number = Math.random,
) => {
  const batches = Math.floor(poolCount / subgridSize);
  if (!Number.isFinite(batches) || batches <= 1) return 0;
  return subgridSize * Math.floor(random() * batches);
};

// The UI's language codes, mapped the same way languageHandler maps them for the API.
export const mediaLocale = (language: string) =>
  language === "ru" ? "ru-RU" : language === "uk" ? "uk-UA" : language === "ar" ? "ar-SA" : "en-US";
